import {management} from '../../../../'

import {VolumeRepository} from "../../../infra/knex/repositories/volume"

import {DeleteRecordsVolumeBySectorUseCase} from './deleteRecordUseCase'


export const deleteVolumeBySector=()=>{
  const repository= new VolumeRepository(management)

  const deleteVolume= new DeleteRecordsVolumeBySectorUseCase(repository)

  return deleteVolume
}
